export const createPreviewIdentity = (values) => ({
  printId: values?.printId || '',
  format: values?.format || '',
  productType: values?.type || values?.productType || '',
});

export const previewIdentitiesMatch = (left, right) =>
  Boolean(
    left && right && left.printId === right.printId && left.format === right.format && left.productType === right.productType
  );

export const createPreviewState = ({ token, identity, totalPages }) => ({
  token,
  identity: { ...identity },
  totalPages: Number(totalPages),
});

export const retainPreviewForIdentity = (preview, identity) =>
  previewIdentitiesMatch(preview?.identity, identity) ? preview : null;

export const canAddPreviewToCart = (preview, identity) =>
  Boolean(preview?.token && Number.isFinite(preview.totalPages) && previewIdentitiesMatch(preview.identity, identity));

export const shouldAcceptPreviewResponse = ({ requestId, activeRequestId, requestIdentity, currentIdentity }) =>
  requestId === activeRequestId && previewIdentitiesMatch(requestIdentity, currentIdentity);
